import AppointmentCtaSectionImplementation from '../implementation/sections/AppointmentCtaSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiAppointmentCtaSectionDTO,
  AppointmentCtaSectionDTO,
} from '@lib/strapi/dtos/components/sections/appointmentCtaSection.dto';

const AppointmentCtaSection = (props: ComponentProps<AppointmentCtaSectionDTO>) => {
  return <AppointmentCtaSectionImplementation {...props}></AppointmentCtaSectionImplementation>;
};

export default AppointmentCtaSection;
